<template>
    <div class="form-group row" v-bind:class="{ 'has-danger' : form.errors.has(name) }">
        <label :class="labelClasses" class="col-form-label" :for="name">{{ computedLabel }}</label>
        <div :class="inputHolderClasses">
            <textarea 
                :autofocus="autofocus" 
                :rows="rows" 
                class="form-control" 
                :id="name" 
                :name="name" 
                v-model="form[name]" 
                :required="required" 
                :disabled="disabled"
            ></textarea>
            <span class="help-block form-control-feedback" v-if="form.errors.has(name)" v-text="form.errors.get(name)"></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'form-textarea',

        props: {
            name: {
                type: String,
                required: true,
            },
            labelClasses: {
                type: String,
                required: false,
                default: 'col-md-3 col-xl-2 col-sm-12',
            },
            inputHolderClasses: {
                type: String,
                required: false,
                default: 'col-md-9 col-xl-10 col-sm-12'
            },
            rows: {
                type: String,
                default: '3',
            },
            form: {
                required: true,
            },
            required: {
                type: Boolean,
                default: false,
            },
            autofocus: {
                type: Boolean,
                default: false,
            },
            label: {
                type: String,
                default: null,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
            }
        },

        computed: {
            computedLabel () {
                let translation = this.label ? this.label : this.name;
                return this.uLang('app.' + translation) + (this.required ? ': *' : ': ');
            }
        }
    }
</script>

<style lang="css" scoped>
</style>
